<template>
  <NewDashboardView v-if="newView" :search-token="searchToken" />
  <Dashboard v-else :search-token="searchToken" />
</template>

<script>
import Dashboard from "@/components/pages/dashboard/Dashboard.vue";
import NewDashboardView from "@/components/pages/dashboard/NewDashboardView.vue";
import {mapState} from "vuex";

export default {
  components: {Dashboard, NewDashboardView},
  name: 'DashboardPage',
  props: {
    searchToken: String,
  },
  computed: {
    ...mapState(['newView']),
  }
}

</script>

<style scoped lang="scss">

</style>